

	<ng-template #collaboratorsContent>

    <div class="content">

        <mat-card appearance="outlined" class="example-card" *ngIf="!userEmail && !userName">
            <mat-card-content>
                <p>
                    You can use collaborators to allow other individuals to have access to your shows
                    both to edit them, and also to start and control the show from both the iOS and
                    Android apps. When logged into the account, they will see a Switch User button in
                    the upper left of the UI to toggle between their current account and your account.
                    In addition, if they access a show code that you own from the {{ siteName }} app,
                    they will be given the option to both listen, and also control the show.
                </p>
            </mat-card-content>
        </mat-card>

        <div style="padding:10px" *ngIf="userEmail || userName">
            <p style="margin:0">
                Collaborator's account of
                <strong>{{ userName || '' }}</strong>
                <strong>({{ userEmail || ''}})</strong>
            </p>
        </div>

        <div class="my-show-table">

            <div class="btn">

                <mat-form-field class="table-search">
                    <mat-label>Search collaborators...</mat-label>
                    <input
                        matInput
                        placeholder="Enter search term here"
                        #search
                        [(ngModel)]="s">
                </mat-form-field>

                <div class="shows-btn">
                    <button
                        mat-raised-button
                        class="add-btn"
                        [ngStyle]="{
                            'background-color': 'var(--primary-color)',
                            'color': 'var(--light-color)'
                        }"
                        (click)="addEdit('')">

                        <span
                            style="line-height:24px;margin-right:5px;display:inline-block;">
                            Add New Collaborator
                        </span>

                        <mat-icon>add_box</mat-icon>

                    </button>
                </div>

            </div>

            <div class="mat-elevation-z8">

                <table
                    mat-table
                    [dataSource]="dataSource"
                    matSort
                    matSortActive="email"
                    matSortDirection="asc">

                    <!-- Email -->
                    <ng-container matColumnDef="email">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="show-sm"
                            width="50%">
                            Email
                        </th>

                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="show-sm">
                            {{ element.email }}
                        </td>
                    </ng-container>

                    <!-- Action -->
                    <ng-container matColumnDef="action">

                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            class="show-sm action-col"
                            width="7%">
                            Action
                        </th>

                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="show-sm action-col">

                            <div class="table-select">

                                <button
                                    mat-icon-button
                                    [matMenuTriggerFor]="menu"
                                    aria-label="Collaborator Actions"
                                    [disabled]="element.processing">

                                    <mat-icon>more_vert</mat-icon>

                                </button>

                                <mat-menu #menu="matMenu">

                                    <button
                                        mat-menu-item
                                        (click)="delete(element.id, element.email)">
                                        <span>Delete</span>
                                    </button>

                                </mat-menu>

                            </div>

                        </td>

                    </ng-container>

                    <tr
                        mat-header-row
                        *matHeaderRowDef="displayedColumns">
                    </tr>

                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns;">
                    </tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td colspan="7" class="mat-cell show-sm">
                            {{ loading ? 'Loading...' : 'No records found.' }}
                        </td>
                    </tr>

                </table>

                <mat-paginator
                    [class]="total_collaborators <= 1 ? 'hidden_dropdown' : ''"
                    [pageSizeOptions]="[10, 50, 100, 250, 500]"
                    aria-label="Select page of the records.">
                </mat-paginator>

            </div>

        </div>

    </div>

</ng-template>




<mat-tab-group *ngIf="isAdminView; else normalView" class="admin-tabs">

    <mat-tab label="Collaborators">
        <ng-template matTabContent>
            <ng-container
                *ngTemplateOutlet="collaboratorsContent">
            </ng-container>
        </ng-template>
    </mat-tab>

    <mat-tab label="Audit Logs">
        <ng-template matTabContent>

            <app-collaborators-logs
                [uuid]="uuid"
                [userEmail]="userEmail"
                [userName]="userName">
            </app-collaborators-logs>

        </ng-template>
    </mat-tab>

</mat-tab-group>




<ng-template #normalView>

    <ng-container
        *ngTemplateOutlet="collaboratorsContent">
    </ng-container>

</ng-template>